import axios from 'axios';
import React from 'react';
import { Button, Glyphicon, NavItem } from 'react-bootstrap';
import ReactPopout from '../../external/ReactPopout';

class MedicalRecordDisplayViewerContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPopout: false
        };  
    }

    togglePopoutWindow = () => {
        this.setState({ isPopout: !this.state.isPopout });
    }

    onEMRDataClick = () => {
        axios.post(`/EMRMedicalRecord/audit/${this.props.memberMasterID}?medicalRecordReviewID=${this.props.medicalRecordReviewID}`);
        this.togglePopoutWindow();
    }

    render() {
        const options = {
            toolbar: 'no',
            location: 'no',
            directories: 'no',
            status: 'no',
            menubar: 'no',
            scrollbars: 'yes',
            resizable: 'yes',
            width: window.screen.width,
            height: window.screen.height,
            top: (o, w) => (w.innerHeight - o.height) / 2 + w.screenY,
            left: (o, w) => (w.innerWidth - o.width) / 2 + w.screenX
        };

        return !this.state.isPopout ?
            <NavItem>
                <Button onClick={this.onEMRDataClick} style= {{ marginLeft: '0.2rem' }} disabled={!this.props.hasEMRData}>
                    <Glyphicon glyph="picture" style={{ fontWeight: '800', marginRight: '0.6rem' }} /> EMR Data
                </Button>
            </NavItem>
            : <ReactPopout title="EMR Data" onClosing={this.togglePopoutWindow} options={options}
                url={`/ReviewProcessing/EMRD?memberMasterID=${this.props.memberMasterID}`}>
              </ReactPopout>
    }
}

export default MedicalRecordDisplayViewerContainer;